export default __webpack_public_path__ + "20d7570bc5296f5127f5ec9353b3eb48.svg";